import React from 'react';
import { ExternalLink, Star } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Reviews } from '../components/Reviews';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
import { GOOGLE_REVIEWS_URL } from '../data/reviews';
export function ReviewsPage() {
  usePageMeta({
    title: "Customer Reviews — 5-Star Mobile Detailing | Mike's Pro Detail",
    description: "Read real 5-star Google and Yelp reviews from Mike's Pro Detail customers across Ventura County. Mobile car detailing that's responsive, on time, and meticulous.",
    path: '/reviews',
    breadcrumbName: 'Reviews'
  });
  return <main data-id="element-1095" data-mp="r0qic9wtwd4z">
      <PageHeader breadcrumb="Reviews" title="5-Star Mobile Detailing Reviews" subtitle="See why Ventura County trusts Mike's Pro Detail for professional mobile car detailing." data-id="element-1096" data-mp="r0yvm2wv5kgp" />

      <section className="w-full bg-black py-16 px-4" data-id="element-1097" data-mp="2lehzduhhlzag">
        <div className="max-w-7xl mx-auto" data-id="element-1098" data-mp="2lezvmr45gdid">
          <p className="mb-10 flex items-center justify-center gap-2 text-gray-300" data-id="element-1099" data-mp="2zc1c1spcxppd">
            <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" aria-hidden="true" data-id="element-1100" data-mp="2zedzgldvws9t" />
            <span className="font-bold" data-id="element-1101" data-mp="3491i43m7isgh">5.0 average rating across Google &amp; Yelp</span>
          </p>
          <Reviews data-id="element-1102" data-mp="2qdpknogo2nvv" />

          <div className="mt-14 max-w-3xl mx-auto text-center border-t border-zinc-800 pt-10" data-id="element-1103" data-mp="2ucoloxza20i1">
            <h2 className="text-3xl md:text-4xl font-black uppercase text-white mb-3" data-id="element-1104" data-mp="3i2sqv9s468b5">
              Check Us Out
            </h2>
            <p className="text-gray-400 text-lg mb-8" data-id="element-1105" data-mp="3n0kie2oujset">
              Read more reviews on Google to see why our customers trust us with
              their vehicles.
            </p>
            <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-6 py-4 bg-white hover:bg-gray-200 text-gray-900 font-bold rounded-lg transition-colors duration-150" data-id="element-1106" data-mp="3dbam0amyznkw">
              <span className="uppercase tracking-wider text-sm" data-id="element-1107" data-mp="9o0ml2qjbpde">
                View Google Reviews
              </span>
              <ExternalLink className="w-4 h-4" aria-hidden="true" data-id="element-1108" data-mp="jgd654iir9cs" />
            </a>
          </div>
        </div>
      </section>

      <CallCta data-id="element-1109" data-mp="ahi0btje01a0" />
    </main>;
}